import { ObjectVisitor } from "../../ObjectVisitor";
import { DotNetTypeMapper } from "./DotNetTypeMapper";
import { NAMESPACE } from "./_Namespace";

export class TypeInitializerObjectVisitor extends ObjectVisitor
{
    public static override classNamespace = NAMESPACE + "TypeInitializerObjectVisitor";
    public static override className = "TypeInitializerObjectVisitor";

    // #region Overrides

    protected override async objectVisitedAsync(obj: any)
    {
        if (obj.$type)
        {
            const
                mappedType = await DotNetTypeMapper.createOptionalAsync(obj.$type, obj);

            if (mappedType)
                return mappedType;

            console.warn(`Could not create type \"${obj.$type}\"`);
        }

        return obj;
    }

    // #endregion
}